/**
 * Enumeration of the 3 different Sort types
 */
export var DataTableSortType;
(function (DataTableSortType) {
    /**
     * No sorting applied, defaults to ASC.
     */
    DataTableSortType[DataTableSortType["NONE"] = 0] = "NONE";
    /**
     * Sort ascending (1, 2, 3)
     */
    DataTableSortType[DataTableSortType["ASC"] = 1] = "ASC";
    /**
     * Sort descending (3, 2, 1)
     */
    DataTableSortType[DataTableSortType["DESC"] = 2] = "DESC";
})(DataTableSortType || (DataTableSortType = {}));
/**
 * Placeholder for a column sort
 */
export class DataTableCurrentSort {
}
